module.exports = __webpack_public_path__ + "cb00b819da6093c52289da36f470549a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansextrabolditalic.woff
// module id = 680
// module chunks = 57